import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { PageResult } from '../interfaces/page-result';
import { Transacao } from '../interfaces/transacao';
import {FatTransacaoD} from '../interfaces/fat-transacao-d';
import {FatTransacaoDR} from '../interfaces/fat-transacao-dr';
import { environment } from '../../../environments/environment';
import { JwtAuthService } from './auth/jwt-auth.service';
import { Diretiva } from '../interfaces/diretiva';

@Injectable({
  providedIn: 'root'
})
export class TransacaoService {

  readonly path = '/transacao/v2';

  constructor(private http: HttpClient, public jwtAuthService: JwtAuthService) { }

  private sanitizePositiveInt(value: unknown, fallback: number): number {
    const parsed = Number(value);
    return Number.isFinite(parsed) && parsed > 0 ? Math.trunc(parsed) : fallback;
  }

  create(): Observable<Transacao> {
    return this.http.post<Transacao>(`${this.jwtAuthService.apiUrl + this.path}`, null);
  }

  saveOrUpdate(cadastro: Transacao): Observable<Transacao> {
    return this.http.put<Transacao>(`${this.jwtAuthService.apiUrl + this.path}`, cadastro);
  }

  getFatTransacao(id: number ): Observable<Transacao> {
    return this.http.get<Transacao>(`${this.jwtAuthService.apiUrl + this.path}/${id}`);
  }

  getFatTransacaoById(id: number ): Observable<Transacao> {
    return this.http.get<Transacao>(`${this.jwtAuthService.apiUrl + this.path}/id/${id}`);
  }

  idemFatTransacao(id: number ): Observable<Transacao> {
    return this.http.get<Transacao>(`${this.jwtAuthService.apiUrl + this.path}/idem/${id}`);
  }

  getFatTransacaoDesc(id: number ): Observable<string> {
    return this.http.get<string>(`${this.jwtAuthService.apiUrl + this.path}/desc/${id}`);
  }

  getFatTransacaoPage(page?: number, size?: number,
    order?: string, direction?: string, desativado?: boolean, conteudo?: boolean, tipoTransacao?: string): Observable<PageResult<Transacao>> {
    const params = new HttpParams({
      fromObject: {
        page: this.sanitizePositiveInt(page, 1).toString(),
        size: this.sanitizePositiveInt(size, 20).toString(),
        order: order ?? 'TODOS',
        direction: direction ?? 'ASC',
        tipoTransacao: tipoTransacao ?? 'FATURAMENTO'
      }
    });

    return this.http.get<PageResult<Transacao>>(`${this.jwtAuthService.apiUrl + this.path}/page/get/`, { params });
  }

  getFatTransacaoPageSearch(page?: number, size?: number,  search?: string,
    order?: string, direction?: string, desativado?: boolean, conteudo?: boolean, tipoTransacao?: string): Observable<PageResult<Transacao>> {
    const params: string[] = [];
    params.push(`page=${this.sanitizePositiveInt(page, 1)}`);
    params.push(`size=${this.sanitizePositiveInt(size, 20)}`);
    if (search !== undefined && search !== null && search !== '' && search !== 'undefined') params.push(`search=${encodeURIComponent(search)}`);
    params.push(`order=${order ?? 'TODOS'}`);
    params.push(`direction=${direction ?? 'ASC'}`);
    params.push(`tipoTransacao=${tipoTransacao ?? 'FATURAMENTO'}`);
    const queryString = params.join('&');
    console.log('queryString', queryString);
    return this.http.get<PageResult<Transacao>>(`${this.jwtAuthService.apiUrl + this.path}/page/get/?${queryString}`);
  }

  deleteFatTransacao(id: number): Observable<any> {
    return this.http.delete<any>(`${this.jwtAuthService.apiUrl + this.path}/${id}`);
  }

  toogleDesativado(id: number): Observable<any> {
    return this.http.put(`${this.jwtAuthService.apiUrl + this.path}/desativar/toggle/${id}`, null);
  }

  getDiretiva(codigo: number ): Observable<Diretiva> {
    return this.http.get<Diretiva>(`${this.jwtAuthService.apiUrl + this.path}/diretiva/${codigo}`);
  }


  getDiretivas(codigo: number ): Observable<FatTransacaoD[]> {
    return this.http.get<FatTransacaoD[]>(`${this.jwtAuthService.apiUrl + this.path}/diretiva/lista/${codigo}`);
  }

  getDiretivasById(id: number ): Observable<FatTransacaoD[]> {
    return this.http.get<FatTransacaoD[]>(`${this.jwtAuthService.apiUrl + this.path}/diretiva/listabyid/${id}`);
  }

  getDiretivaProp(transacaoId: number, diretivaId: number ): Observable<FatTransacaoDR[]> {
    return this.http.get<FatTransacaoDR[]>(`${this.jwtAuthService.apiUrl + this.path}/diretiva/lista/prop/${transacaoId}/${diretivaId}`);
  }

  saveDiretivaProps(transacaoId: number, diretivaId: number, values: FatTransacaoDR[]): Observable<FatTransacaoDR[]> {
    return this.http.put<FatTransacaoDR[]>(`${this.jwtAuthService.apiUrl
      + this.path}/diretiva/lista/prop/${transacaoId}/${diretivaId}`, values);
  }


  addDiretiva(transacaoId: number, diretivaId: number ): Observable<FatTransacaoD[]> {
    return this.http.put<FatTransacaoD[]>(`${this.jwtAuthService.apiUrl + this.path}/diretiva/${transacaoId}/${diretivaId}`, null);
  }

  deleteDiretivaProp(transacaoId: number, diretivaId: number, regraId: number): Observable<FatTransacaoDR[]> {
    return this.http.delete<FatTransacaoDR[]>(`${this.jwtAuthService.apiUrl + this.path}/diretiva/${transacaoId}/${diretivaId}/${regraId}`);
  }


  exportar(codigo: any, filialDestinoId: any): Observable<any> {
    return this.http.put(`${this.jwtAuthService.apiUrl}/transacao/exportar/${codigo}/${filialDestinoId}`, null);
   }



}
